import { AlertTriangleIcon, HourglassIcon } from '@assets/icons';
import { IconButton } from '@components/button';
import { Tooltip } from '@components/tooltip';
import { Box } from '@mui/material';

interface DatasetStatusIconProps {
  status: string;
  workspaceId: string;
  datasetId: string;
}

export const DatasetStatusIcon = ({ status, workspaceId, datasetId }: DatasetStatusIconProps) => {
  const lowerStatus = (status || '').toLocaleLowerCase();

  const url = `/workspaces/${workspaceId}/jobs/${datasetId}`;

  if (lowerStatus === 'failed' || lowerStatus === 'cancelled') {
    return (
      <Tooltip title="View logs" variant="secondary" disableInteractive>
        <IconButton
          Icon={AlertTriangleIcon}
          variant="error"
          size={16}
          onClick={(e) => {
            e.preventDefault();
            window.open(url, '_blank');
          }}
          style={{ cursor: 'pointer' }}
        />
      </Tooltip>
    );
  }
  if (
    lowerStatus !== 'success' &&
    lowerStatus !== 'completed' &&
    lowerStatus !== 'complete' &&
    lowerStatus !== 'failed' &&
    lowerStatus !== 'cancelled'
  ) {
    return (
      <Box sx={{ px: '6px', pt: '6px', pb: '1px' }}>
        <HourglassIcon size={16} />
      </Box>
    );
  }
  return null;
};
